import React from "react"
import PropTypes from "prop-types"

import "./service.scss"

export default function Service({ service }) {
  return (
    <div styleName="service-item">
      <a
        href={`/${service.module_name}`}
        data-track-ifttt-next-event="click"
        data-track-data={JSON.stringify({
          object_type: "service",
          object_id: service.module_name,
          location_type: "connections_between_services",
        })}
      >
        <img
          src={service.icon_bw}
          title={service.name}
          alt={service.name}
          styleName="service-icon"
        />
        <h3 styleName="service-title">{service.name}</h3>
        <div styleName="service-description">
          <span
            dangerouslySetInnerHTML={{
              __html: `${service.description}`,
            }}
          />
        </div>
      </a>
    </div>
  )
}

Service.propTypes = {
  service: PropTypes.shape({
    call_to_action: PropTypes.shape({
      text: PropTypes.string,
      link: PropTypes.string,
    }),
    description: PropTypes.string.isRequired,
    icon_bw: PropTypes.string.isRequired,
    module_name: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
}
